module.exports = __webpack_public_path__ + "assets/img/travel-day3.6b5bd62a.png";